import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  orderId: null,
  cartCount: 0,
  products: [],
  subscriptions: [],
  cart: [],
  discount: 0,
  total: 0,
  subtotal: 0,
  product: null,
  cartobj: {},
  cartdata: {},
  // checkout: {
  //   activeStep: 0,
  //   cart: [],
  //   subtotal: 0,
  //   total: 0,
  //   discount: 0,
  //   shipping: 0,
  //   billing: null,
  //   totalItems: 0,
  // },
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getProductsSuccess(state, action) {
      state.isLoading = false;
      state.products = action.payload;
    },
    // GET Cart
    getCartSuccess(state, action) {
      state.isLoading = false;
      const data = action.payload;
      state.orderId = data.id;
      state.cart = data.orderItems;
      state.discount = data.couponAmount;
      state.total = data.total ?? 0;
      state.subtotal = sum(data.orderItems.map((item) => item.price * item.qty));
      const totalCartItems = sum(data.orderItems.map((item) => item.qty));
      state.cartCount = totalCartItems;
    },
    // GET Cart
    reloadCartSuccess(state, action) {
      state.isLoading = false;
      state.cartCount = action.payload;
    },

    // GET PRODUCT
    getProductSuccess(state, action) {
      state.isLoading = false;
      state.product = action.payload;
    },

    // GET SUBSCRIPTIONS
    getSubscriptionsSuccess(state, action) {
      state.isLoading = false;
      state.subscriptions = action.payload;
    },

    // CHECKOUT
    getCart(state, action) {
      // state.checkout  = action.payload;
    },

    addToCart(state, action) {
      // const newProduct = action.payload;
      // const isEmptyCart = !state.checkout.cart.length;
      // if (isEmptyCart) {
      //   state.checkout.cart = [...state.checkout.cart, newProduct];
      // } else {
      //   state.checkout.cart = state.checkout.cart.map((product) => {
      //     const isExisted = product.id === newProduct.id;
      //     if (isExisted) {
      //       return {
      //         ...product,
      //         colors: uniq([...product.colors, ...newProduct.colors]),
      //         quantity: product.quantity + 1,
      //       };
      //     }
      //     return product;
      //   });
      // }
      // state.checkout.cart = uniqBy([...state.checkout.cart, newProduct], 'id');
      // state.checkout.totalItems = sum(state.checkout.cart.map((product) => product.quantity));
    },

    deleteCart(state, action) {
      // const updateCart = state.checkout.cart.filter((product) => product.id !== action.payload);
      // state.checkout.cart = updateCart;
    },

    resetCart(state) {},

    backStep(state) {
      // state.checkout.activeStep -= 1;
    },

    nextStep(state) {
      // state.checkout.activeStep += 1;
    },

    gotoStep(state, action) {
      // const step = action.payload;
      // state.checkout.activeStep = step;
    },

    increaseQuantity(state, action) {
      // const productId = action.payload;
      // const updateCart = state.checkout.cart.map((product) => {
      //   if (product.id === productId) {
      //     return {
      //       ...product,
      //       quantity: product.quantity + 1,
      //     };
      //   }
      //   return product;
      // });
      // state.checkout.cart = updateCart;
    },

    decreaseQuantity(state, action) {
      // const productId = action.payload;
      // const updateCart = state.checkout.cart.map((product) => {
      //   if (product.id === productId) {
      //     return {
      //       ...product,
      //       quantity: product.quantity - 1,
      //     };
      //   }
      //   return product;
      // });
      // state.checkout.cart = updateCart;
    },

    createBilling(state, action) {
      state.checkout.billing = action.payload;
    },

    applyDiscount(state, action) {
      // const discount = action.payload;
      // state.checkout.discount = discount;
      // state.checkout.total = state.checkout.subtotal - discount;
    },

    applyShipping(state, action) {
      // const shipping = action.payload;
      // state.checkout.shipping = shipping;
      // state.checkout.total = state.checkout.subtotal - state.checkout.discount + shipping;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

export function getProducts(product) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/products/all');
      dispatch(slice.actions.getProductsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSubscriptions(subscriptions) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/productsubs/all');
      dispatch(slice.actions.getSubscriptionsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCarItems() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('orders/my-cart');
      dispatch(slice.actions.getCartSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function applyCoupon(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.getCartSuccess(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function reloadCart(cartCount) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.reloadCartSuccess(cartCount));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getProduct(product) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.getProductSuccess(product));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
